import PropTypes from 'prop-types';
import { Button } from '@ui-propulsion/react-components';
import { useState, useEffect } from 'react';
import SocialIcons from '../socialIcons/socialIcons';
import styles from './postBody.module.scss';
import { ctaTheme, setExternalLinksTargetBlank } from '../../utils/util';

function PostBody({
  slug = '',
  postContent = '',
  ctaButton = null,
  showShare = false,
  className = '',
  showContinueReading = false,
  contentType = 'Blog',
}) {
  const socialData = {
    title: 'Share',
    type: 'share',
    articleUrl: `https://www.lendingclub.com${slug}`,
  };
  const [isContinueRead, setIsContinueRead] = useState(false);
  const [ctaThemes, setCtaThemes] = useState(styles.redOutline);

  useEffect(() => {
    if (ctaButton?.ctaTheme) setCtaThemes(ctaTheme(ctaButton?.ctaTheme));
  }, [ctaButton]);

  useEffect(() => {
    setIsContinueRead(showContinueReading);
  }, [showContinueReading]);

  return (
    <>
      <div
        itemType="https://schema.org/articleSection"
        itemProp={`${contentType === 'Blog' ? 'articleSection' : ''}`}
        className={`${styles.postBody} ${
          className && styles[className] ? styles[className] : ''
        } ${isContinueRead ? styles.hideOverflow : ''}`}
      >
        <article
          className={styles.bodyContent}
          itemType="https://schema.org/articleBody"
          itemProp={`${contentType === 'Help' ? 'text' : 'articleBody'}`}
        >
          {setExternalLinksTargetBlank(postContent)}
        </article>
        {ctaButton && ctaButton.label && (
          <div className={styles.ctaButton}>
            <Button
              aria-label="link-button"
              variant="tertiary"
              type="button"
              href={ctaButton.link}
              className={ctaThemes}
            >
              {ctaButton.label}
            </Button>
          </div>
        )}
        {showShare && (
          <div className={styles.sharIcons}>
            <SocialIcons {...socialData} />
          </div>
        )}
      </div>
      {isContinueRead && (
        <div className={styles.continueReadingContainer}>
          <div className={styles.continueReading}>
            <Button
              aria-label="link-button"
              variant="secondary"
              color="red"
              type="button"
              onClick={() => setIsContinueRead(false)}
            >
              Continue Reading
            </Button>
          </div>
        </div>
      )}
    </>
  );
}
export default PostBody;

PostBody.propTypes = {
  slug: PropTypes.string,
  postContent: PropTypes.string,
  ctaButton: PropTypes.shape({
    label: PropTypes.string,
    link: PropTypes.string,
  }),
  showShare: PropTypes.bool,
  className: PropTypes.string,
  showContinueReading: PropTypes.bool,
  contentType: PropTypes.oneOf(['Blog', 'Help']),
};
